export const tableColumnList = [
  {
    field: 'settlementDesc', // 1
    title: '结算说明',
    width: '120',
    editRender: {
      name: 'settlementDesc',
    },
  },
  {
    field: 'supplierName',
    title: '供应商名称',
    width: '140',
    editRender: { name: 'supplierName' },
  },
  {
    field: 'contractNo',
    title: '合同编号',
    width: '140',
    editRender: { name: 'contractNo' },
  },

  {
    field: 'originalPrice',
    title: '原币结算单价(含税)',
    width: '150',
    editRender: { name: 'originalPrice' },
  },
  {
    field: 'settlementQuantity',
    title: '结算数量',
    width: '140',
    editRender: {
      name: 'settlementQuantity',
    },
  },
  {
    field: 'unit',
    title: '计量单位',
    width: '140',
    editRender: {
      name: 'unit',
    },
  },
  {
    field: 'originalAmount',
    title: '原币结算金额(含税)',
    width: '160',
    editRender: {
      name: 'originalAmount',
    },
  },
  {
    field: 'originalAmountWithoutTax',
    title: '原币结算金额 (不含税)',
    width: '160',
    editRender: { name: 'originalAmountWithoutTax' },
  },
  {
    field: 'originalTaxAmount',
    title: '原币税额',
    width: '140',
    editRender: { name: 'originalTaxAmount' },
  },
  {
    field: 'currencyName',
    title: '币种',
    width: '140',
    editRender: { name: 'currencyName' },
  },
  {
    field: 'exchangeRate',
    title: '汇率',
    width: '140',
    editRender: { name: 'exchangeRate' },
  },
  {
    field: 'domesticAmount',
    title: '本币结算金额（含税）',
    width: '170',
    editRender: { name: 'domesticAmount' },
  },
  {
    field: 'domesticAmountWithoutTax',
    title: '本币结算金额 (不含税)',
    width: '160',
    editRender: { name: 'domesticAmountWithoutTax' },
  },
  {
    field: 'domesticTaxAmount',
    title: '本币税额',
    width: '140',
    editRender: { name: 'domesticTaxAmount' },
  },
  {
    field: 'additional',
    title: '附加',
    width: '140',
    editRender: { name: 'additional' },
  },

  // {
  //   field: 'businessName',
  //   title: '业务(作业)名称',
  //   width: '140',
  //   editRender: { name: 'businessName' },
  // },

  {
    field: 'productCode',
    title: '商品名称',
    width: '140',
    editRender: { name: 'productCode' },
  },
  {
    field: 'goodsCategoryName',
    title: '商品类别',
    width: '140',
    editRender: { name: 'goodsCategoryName' },
  },
  {
    field: 'productModel',
    title: '规格',
    width: '140',
    editRender: { name: 'productModel' },
  },
  {
    field: 'businessDocNo',
    title: '业务单据编号',
    width: '140',
    editRender: { name: 'businessDocNo' },
  },

  {
    field: 'deductDesc',
    title: '扣除说明',
    width: '140',
    editRender: { name: 'deductDesc' },
  },
  {
    field: 'deductAmount',
    title: '扣除金额',
    width: '140',
    editRender: { name: 'deductAmount' },
  },
  {
    field: 'originalPracticalSettlementAmount',
    title: '原币结算实际金额（含税）',
    width: '140',
    editRender: { name: 'originalPracticalSettlementAmount' },
  },
  {
    field: 'originalPracticalAmountWithoutTax',
    title: '原币结算实际金额（不含税）',
    width: '140',
    editRender: { name: 'originalPracticalAmountWithoutTax' },
  },
  {
    field: 'domesticPracticalSettlementAmount',
    title: '本币结算实际金额（含税）',
    width: '140',
    editRender: { name: 'domesticPracticalSettlementAmount' },
  },
  {
    field: 'domesticPracticalAmountWithoutTax',
    title: '本币结算实际金额（不含税）',
    width: '140',
    editRender: { name: 'domesticPracticalAmountWithoutTax' },
  },
  {
    field: 'remark',
    title: '备注',
    width: '140',
    editRender: { name: 'remark' },
  },
];

export const tableRules = {
  // settlementDesc: [{ required: true, message: '必填字段' }],
  // originalPrice: [{ required: true, message: '必填字段' }],
  // originalAmount: [{ required: true, message: '必填字段' }],
  currencyName: [{ required: true, message: '必填字段' }],
  exchangeRate: [{ required: true, message: '必填字段' }],
  // domesticAmount: [{ required: true, message: '必填字段' }],
  productCode: [{ required: true, message: '必填字段' }],
  // contractNo: [{ required: true, message: '必填字段' }],
};
